
export const Constant = {
    couleurPrimaire: "#6D859E",
    couleurSecondaire: "#E93323",
    textPrimaire: "white",
    userLocal: "user",
    tokenLocal: "token",
    CleDeSevob: "4n",
    devis: "FCFA",
    champObligatoire: "Ce champs est obligatoire",
    pasApiActiver: "Vous n'avez pas d'api activé pour",
    faireRetrait: "Faire un retrait",
    faireRecharge: "Recharger mon compte",
    insererNumeros: "Veuillez saisir au minimum un numéro",
    acheterSms: "Acheter des SMS maintenant",
    activerAbonnement: "Activer mon abonnement",
    envoyerSms: "Envoyer des SMS",
    faireTransfert: "Faire un transfert",
    clientGestion: "Mes groupes",
    mesExpediteur: "Mes expéditeurs",
    lienLogo: "https://www.sevob.net/SEVOB.png",
    lienQrCode: "https://www.sevob.net/#/QrCode/",
    acheter: "Acheter",
    SevobTest: "SEVOB",
    faireRetraitSevob: "Faire un retrait sur le compte de SEVOB",
    faireTransfertSevob: "Faire un transfert depuis le compte de SEVOB",
    conceptionLogiciel: "Conception de logiciel",
    integrationGps: "Intégration des gps",
    formationProfessionnelles: "Formations professionnelles",
    venteEtPrestation: "Ventes et prestation de service",
    paiementweb: "paiementweb",
    gpstrack: "gpstrack",
    sms: "sms",
    qrcode: "qr",
    offline: "offline",
    Valider: "Validé",
    depart: "Départ",
    FONCTIONNEL: "FONCTIONNEL",
    Autre: "Autre",
    DAMAGED: "DAMAGED",
    LOSE: "LOSE",
    INSTALLED: "INSTALLED",
    CONFIGURED: "CONFIGURED",
    lienNonValide: "Ce lien n'est pas valide",
    positionActuelle: '<h4>Votre position actuelle</h4>',
    appartenance: [
        { "value": "", "label": "Toutes" },
        { "value": "SEVOB", "label": "SEVOB" },
        { "value": "FABA Logistique", "label": "FABA Logistique" },
      ],
    statusGps: [
      { value: "En ligne", label: "online", color: "green" },
      { value: "Hors ligne", label: "offline", color: "red" },
      { value: "Vitesse limite dépassée", label: "speed_alert", color: "red" },
      { value: "Batterie faible", label: "low_battery", color: "orange" },

      { value: "Coupure d'alimentation", label: "power_cut", color: "red" },
      { value: "Entrée zone plateforme", label: "enter_platform_zone", color: "orange" },
      { value: "Sortie zone plateforme", label: "exit_platform_zone", color: "orange" },
      { value: "Statut GPS", label: "gps_status", color: "orange" },
      { value: "Détection de mouvement", label: "sense_of_motion", color: "orange" },
      { value: "Véhicule en mouvement", label: "car_driving", color: "green" },

      { value: "SOS", label: "sos_alarm", color: "red" },
      { value: "Alarme de mouvement", label: "movement_alarm", color: "orange" },
      { value: "Extinction", label: "power_down", color: "gray" },
      { value: "Coupure moteur", label: "cut_off_engine", color: "red" },
      { value: "Porte ouverte", label: "car_door_opened", color: "orange" },
      { value: "Anti-vol", label: "anti_theft_alarm", color: "red" },
      { value: "Mode économie d'énergie", label: "power_saving", color: "orange" },
      { value: "Contact (ACC ON)", label: "acc_on", color: "green" },

      { value: "Entrée géofence 1", label: "enter_geofence_1", color: "orange" },
      { value: "Sortie géofence 1", label: "exit_geofence_1", color: "orange" },
      { value: "Entrée géofence 2", label: "enter_geofence_2", color: "orange" },
      { value: "Sortie géofence 2", label: "exit_geofence_2", color: "orange" },
      { value: "Entrée géofence 3", label: "enter_geofence_3", color: "orange" },
      { value: "Sortie géofence 3", label: "exit_geofence_3", color: "orange" },
    ],
    typeVehiculeGps: [
      { value: "MOTO", label: "MOTO", icon: "MotorcycleOutlined" },
    ],
    etat: [
        { "value": "", "label": "Tout" },
        { "value": "CONFIGURED", "label": "Configuré" },
        { "value": "INSTALLED", "label": "Installé" },
        { "value": "FONCTIONNEL", "label": "Fonctionnel" },
        { "value": "DAMAGED", "label": "Non fonctionnel" },
        { "value": "LOSE", "label": "Perdu" },
      ],
    ApiList: [
        { "value": "paiementweb", "label": "Paiements en ligne" },
        { "value": "gpstrack", "label": "GPS tackeurs" },
        { "value": "sms", "label": "SMS" },
        { "value": "qrcode", "label": "Qr code" },
      ],
    ROLE_USERS: "ROLE_USERS",
    ROLE_SEVOB_SUPER_ADMIN: "ROLE_SEVOB_SUPER_ADMIN",
    ROLE_EMPLOYE: "ROLE_EMPLOYE",
    ROLE_STATISTIQUES_SEVOB: "ROLE_STATISTIQUES_SEVOB",
    ROLE_MODIFIER_FACTURATION: "ROLE_MODIFIER_FACTURATION",
    ROLE_MODIFIER_TYPE_FACTURATION: "ROLE_MODIFIER_FACTURATION",
    ROLE_TRANSFERT_SEVOB: "ROLE_TRANSFERT_SEVOB",
    ROLE_RETRAIT_SEVOB: "ROLE_RETRAIT_SEVOB",
    ROLE_GESTION_UTILISATEUR: "ROLE_GESTION_UTILISATEUR",
    ROLE_GESTION_UTILISATEUR_TRANSACTIONS_TEST: "ROLE_GESTION_UTILISATEUR_TRANSACTIONS_TEST",
	  ROLE_GESTION_UTILISATEUR_TRANSACTIONS: "ROLE_GESTION_UTILISATEUR_TRANSACTIONS",
	  ROLE_GESTION_UTILISATEUR_API: "ROLE_GESTION_UTILISATEUR_API",
	  ROLE_GESTION_UTILISATEUR_COMPTE: "ROLE_GESTION_UTILISATEUR_COMPTE",
	  ROLE_GESTION_UTILISATEUR_RECHERCHE: "ROLE_GESTION_UTILISATEUR_RECHERCHE",
	  ROLE_GESTION_API: "ROLE_GESTION_API",
	  ROLE_GESTION_API_AJOUT: "ROLE_GESTION_API_AJOUT",
	  ROLE_GESTION_API_SMS_SENDER_ID: "ROLE_GESTION_API_SMS_SENDER_ID",
	  ROLE_GESTION_RETRAIT: "ROLE_GESTION_RETRAIT",
    visible: "visible",
    hidden: "hidden",
    noAccess: "L'accès vous est refusé.",
    ios: "Application IOS",
    Android: "Application Android",
    web: "Site web",
    Image: "Image",
    video: "Vidéo et autres",
    Text: "Text",
    paths: {
      login: "/auth/login",
      addClient: "/anonymous/addClient",
      SendCode: "/anonymous/SendCode",
      VerificationCode: "/anonymous/VerificationCode",
      ModificationMotDePasse: "/anonymous/ModificationMotDePasse",
      gpsLastPositionData: "/users/gpsLastPositionData",
      addGps: "/users/addGps",
      deleteGps: "/users/deleteGps",
      updateGps: "/users/updateGps",
    },
    couleur: {
      primary: "#6D859E",
      secondary: "#E93323",
      white: "white",
      black: "black",
    },
    baliseData: {
      typeChamp: {
          NumeroEtudiant: "NumeroEtudiant",
          Inputs: "Inputs",
          InputsArea: "InputsArea",
          Buttons: "Buttons",
          Radios: "Radios",
          RadiosGroup: "RadiosGroup",
          Checkbox: "Checkbox",
          DatePicker: "DatePicker",
          Picker: "Picker",
          Photo: "Photo",
          Image: "Image",
          Pdf: "pdf",
          Contries: "Contries",
          TimePicker: "TimePicker",
          RangePicker: "RangePicker",
          CKeditor: "CKeditor",
          Engagement: "Engagement",
          Text: "Text",
          Phone: "Phone",
      },
      typeBouton:{
          primary: "primary",
          default: "default",
          dashed: "dashed",
        },
      size:{
          large: "large",
        small: "small",
        middle: "middle",
      },
      layout:{
          horizontal: "horizontal",
        vertical: "vertical",
      },
      precision:{
        week: 'week',
        weekday: 'week-day',
        year: 'year',
        month: 'month',
        day: 'day',
        hour: 'hour',
        minute: 'minute',
        second: 'second'
      },
      layoutForm:{
        vertical: "vertical",
        horizontal: "horizontal",
      },
      required:{
          champsObligatoire: "champsObligatoire",
        emailNoValid: "emailNoValid",
      },
      onPress:{
        validate: "validate",
        return: "return",
      },
      pickerMode:{
        multiple: "multiple",
        tags: "tags",
      },
      shape:{
        circle: "circle",
        default: "default",
        round: "round",
      },
      iconPosition:{
        end: "end",
        start: "start",
      },
    },
    fr: {
      AjoutGps: "Ajout de GPS",
      longitude: "Longitude",
      latitude: "Latitude",
      altitude: "Altitude",
      batteryLevel: "Batterie",
      fuelLevel: "Carburant",
      satellites: "Satellite",
      accuracy: "Précision",
      id: "Id",
      protocole: "Protocole",
      rawData: "Donnée reçu",
      serverTime: "Date et heure du serveur",
      deviceTime: "Date et heure du GPS",
      ModificationGps: "Modification de GPS",
      Ajouter: "Ajouter",
      Filtrer: "Filtrer",
      Rapports: "Rapports",
      Cacher: "Cacher",
      Afficher: "Afficher",
      Connexion: "Connexion",
      Inscription: "Inscription",
      motDePasseOublie: "Mot de passe oublié",
      Fermer: "Fermer",
      Modifier: "Modifier",
      Verifier: "Vérifier",
      seconnecter: "Se connecter",
      sinscrire: "S'inscrire",
      Email: "Email",
      nomIndividuEntreprise: "Nom individu/Entreprise",
      lieu: "Lieu",
      telephone: "Téléphone",
      numero: "Numéro",
      password: "Mot de passe",
      choosePays: "Sélectionnez un pays",
      prenom: "Prénom",
      champsObligatoire: "Ce champs est obligatoire",
      minObligatoire: "Ce champs doit avoir au moins %1 caractères !",
      emailNoValid: "Cet email n'est pas valide",
      accesRefuse: "Votre demande d'accès a été refusée. Veuillez vérifier vos informations et votre connexion.",
      send: "Envoyer",
      JWT_EXPIRED: "Token expiré",
      JWT_INVALID: "Token invalide",
      code: "Code",
      nouveaupassword: "Nouveau mot de passe",
      confirmationpassword: "Confirmer le nouveau mot de passe",
      motDePasseConfirmationDifferent: "La confirmation du nouveau mot de passe n'est pas identique",
      erreurServeur: "Erreur du serveur. Verifier votre connexion internet.",
      imei: "Imei",
      nom: "Nom",
      description: "Description",
      type: "Type",
      contact: "Contact",
      Vitesse: "Vitesse",
      Distance: "Distance",
      Orientation: "Orientation",
      suppressionConfirmation: "Etes-vous sûr de vouloir cette suppression ?",
    }
}